// Prévia no navegador: sem alertas do sistema.
export const initNotifications = async () => false;
export const rescheduleAll = async (_docs: unknown) => {};
export const cancelAll = async () => {};

export const definirConversaAberta = (_f: () => string | null) => {};
export type ResultadoTeste = 'ok' | 'sem-permissao' | 'som-desligado' | 'canal-desligado' | 'canal-mudo' | 'resumo'
  | 'nao-perturbe' | 'desligado' | 'indisponivel' | 'erro';
export const testarAlerta = async (_modo?: unknown): Promise<ResultadoTeste> => 'indisponivel';
export const garantirCanais = async (_l?: unknown) => {};
export const garantirCanaisVibracao = async (_v?: unknown) => {};
export const proximosAlertas = async (_n?: number): Promise<{ titulo: string; quando: Date }[]> => [];
export const totalAgendados = async () => 0;
export const avisarPublicacoes = async (_n: number) => {};
export const avisarRecebidos = async (_n: number) => {};
/** No navegador não há o módulo de notificações do celular (lembretes, sessão de estudo, push). */
export const modNotificacoes = (): any => null;
export const alertasDisponiveis = () => false;
